import { ca } from '@cian/analytics';

export function trackClick() {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'Card',
    label: 'brochure',
    useLastProducts: true,
    name: 'oldevent',
  });
}
